<template>
  <div>
    <div v-for="(category, index) in categories" v-bind:key="index">
      <div class="card mt-2">
        <div class="card-header p-2 pl-3 category-header">
          {{ category }}
        </div>
        <div class="card-body">
          <div  class="pb-2" v-for="document in collateral.filter((x) => x.category === category )" :key="document.name">
            <downloadable-document v-bind:file="document"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadableDocument from './DownloadableDocument'

export default {
  name: '',
  components: {DownloadableDocument},
  props: ['collateral'],
  data: function () {
    return {
      categories: [
        'Upcoming Events',
        'General Documents',
        'BOD Meeting Minutes',
        'Ex Com Meeting Minutes',
        'Nominating and Governance Committee',
        'Important MAA Work'
      ]
    }
  }
}
</script>

<style scoped>
.category-header {
  font-size: 1.0em;
  font-weight: 500;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/boardOfDirectors/Collateral.vue